import { Link, ListBox, Table } from '@flos/react-ui';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { formatConditionsAndExclusionsToFieldValues } from '../../../utils/coverablesUtil';
import TableRowMultipleValues from '../../../shared_components/TableRowMultipleValues/TableRowMultipleValues';
import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { hippoTermsDocInfoSelector } from '../../../recoil/selectors/hippoTermsDocInfoSelector';
import type { TermsAssetDocument } from '../../../constants/hippoTypes';
import useWindowSize from '../../../hooks/useWindowSize';

const CoverableDetailsConditionAndExclusions = ({
    coverable
}: {
    coverable: CoverableDTO;
}): React.JSX.Element => {
    const { isMobileDevice } = useWindowSize();
    const listBoxIsOpen = !isMobileDevice;
    const conditionsAndExclusionsFieldValues = useMemo(() => {
        const conditionsAndExclusionsDTO = coverable.conditionExclusionManualTexts ?? [];
        return formatConditionsAndExclusionsToFieldValues(conditionsAndExclusionsDTO);
    }, [coverable.conditionExclusionManualTexts]);
    const openTermsDoc = (docPath: string): boolean => {
        window.open(`//topdanmark.dk${docPath}`, '_blank')?.focus();
        return false;
    };
    const termsDocInfo = useRecoilValue(hippoTermsDocInfoSelector);
    const termsDocInfoForThisCoverable = termsDocInfo.filter((termDoc) =>
        coverable.termIds?.includes(termDoc.termsId)
    );
    const termDocs = termsDocInfoForThisCoverable
        .map((termsAsset) =>
            termsAsset.termsAssetCompoundModel.map((termsAssetDoc: TermsAssetDocument) => ({
                ...termsAssetDoc,
                termsId: termsAsset.termsId
            }))
        )
        .flat(1);

    return (
        <div className="u-spacing-inset-m--stretch-max">
            <ListBox
                title={'Vilkår for ' + (coverable.flavourName.toLocaleLowerCase() ?? 'forsikring')}
                isOpen={listBoxIsOpen}
            >
                <Table>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>Vilkår</Table.Cell>
                            <Table.Cell align="right">
                                {termDocs.map((termDoc) => (
                                    <div key={termDoc.termsId}>
                                        <Link
                                            className="u-color-primary-2-base u-Normalwrap"
                                            onClick={() => openTermsDoc(termDoc.assetDocumentUrl)}
                                        >
                                            {termDoc.termsId} {termDoc.description}
                                        </Link>
                                    </div>
                                ))}
                            </Table.Cell>
                        </Table.Row>
                        <TableRowMultipleValues
                            rowInfo={{
                                name: 'Særlige vilkår',
                                fieldValue: conditionsAndExclusionsFieldValues
                            }}
                        />
                    </Table.Body>
                </Table>
            </ListBox>
        </div>
    );
};

export default CoverableDetailsConditionAndExclusions;
